const toBoundaryEpoch = (year: number, monthIndex: number, day: number, boundary: 'start' | 'end'): number => {
  const ms = boundary === 'start'
    ? Date.UTC(year, monthIndex, day, 0, 0, 0, 0)
    : Date.UTC(year, monthIndex, day, 23, 59, 59, 999);
  return Math.floor(ms / 1000);
};

export const parseDateToEpoch = (value: unknown, boundary: 'start' | 'end' = 'start'): number | undefined => {
  if (!value) {
    return undefined;
  }

  if (value instanceof Date) {
    if (!Number.isFinite(value.getTime())) {
      return undefined;
    }
    return toBoundaryEpoch(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate(), boundary);
  }

  if (typeof value === 'string') {
    const dateOnlyMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnlyMatch) {
      const year = Number(dateOnlyMatch[1]);
      const monthIndex = Number(dateOnlyMatch[2]) - 1;
      const day = Number(dateOnlyMatch[3]);

      if (Number.isFinite(year) && Number.isFinite(monthIndex) && Number.isFinite(day)) {
        return toBoundaryEpoch(year, monthIndex, day, boundary);
      }
    }

    const slashMatch = value.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (slashMatch) {
      const monthIndex = Number(slashMatch[1]) - 1;
      const day = Number(slashMatch[2]);
      const year = Number(slashMatch[3]);

      if (Number.isFinite(year) && Number.isFinite(monthIndex) && Number.isFinite(day)) {
        return toBoundaryEpoch(year, monthIndex, day, boundary);
      }
    }

    const parsedDate = new Date(value);
    if (Number.isFinite(parsedDate.getTime())) {
      return toBoundaryEpoch(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate(), boundary);
    }
  }

  return undefined;
};
